// app/lib/firebase-client.ts
import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBEXFmUvsxJBq1Rz5__Dk4FE1PMP4bL5ps",
  authDomain: "incredmoney.firebaseapp.com",
  projectId: "incredmoney",
  storageBucket: "incredmoney.appspot.com",
  messagingSenderId: "150530677387",
  appId: "1:150530677387:web:57f2f870135fbd4300128e",
  measurementId: "G-BEZ0B3HSEH",
};

export const getFirebaseApp = (): FirebaseApp => {
  if (!getApps().length) {
    return initializeApp(firebaseConfig);
  }
  return getApp();
};
